import script from "./ResourcesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourcesPage.vue?vue&type=script&setup=true&lang=js"

import "./ResourcesPage.vue?vue&type=style&index=0&id=ae099c30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae099c30"]])

export default __exports__